// SevenUniverse Contract ABI - Updated to match current contract
export const CONTRACT_ABI = [
  // View functions for user data
  "function getUserIdByAddress(address userAddress) external view returns (uint256)",
  "function getUserDetails(uint256 userId) external view returns (address account, uint256 id, uint256 referrer, bool isActive, uint256 totalDirectReferrals, uint256 claimableAmount, uint256 totalClaimed, uint256 totalIncome)",
  "function getUserPackageDetails(uint256 userId, uint256 packageId) external view returns (bool isActive, uint256 activationTime, uint256 totalInvested, uint256 totalEarned, uint256 ceilingLimit, uint256 remainingLimit)",
  "function getUserPackages(uint256 userId) external view returns (bool[7] memory activePackages)",
  "function getUserIncomeBreakdown(uint256 userId) external view returns (uint256 sponsorIncome, uint256 levelIncome, uint256 galaxyPoolIncome, uint256 cosmosPoolIncome, uint256 universePoolIncome, uint256 eternalPoolIncome, uint256 totalIncome, uint256 claimableAmount, uint256 totalClaimed)",
  "function getUserReferrals(uint256 userId) external view returns (uint256[] memory)",
  "function getPoolEligibilities(uint256 userId) external view returns (bool galaxyEligible, bool cosmosEligible, bool universeEligible, bool eternalEligible)",
  "function getUserClaimablePoolIncomes(uint256 userId) external view returns (uint256 galaxyClaimable, uint256 cosmosClaimable, uint256 universeClaimable, uint256 eternalClaimable)",
  "function getMatrixDetails(uint256 userId, uint256 packageId) external view returns (uint256 upline, uint256[] memory directDownlines, uint256 totalTeamSize)",
  
  // New matrix and activity functions
  "function getMatrixLevelUsers(uint256 userId, uint256 packageId, uint256 level) external view returns (uint256[] memory)",
  "function getMatrixLevelCounts(uint256 userId, uint256 packageId) external view returns (uint256[10] memory levelCounts)",
  "function getUserActivities(uint256 userId) external view returns (tuple(uint256 id, uint256 userId, uint256 activityType, uint256 amount, uint256 packageId, uint256 fromId, uint256 timestamp)[] memory)",
  "function getPoolDistributionInfo(uint256 poolType) external view returns (uint256 currentRound, uint256 latestAmountPerUser, uint256 totalRounds)",
  
  // Pool information
  "function getAllPoolAccumulations() external view returns (uint256, uint256, uint256, uint256)",
  "function getPoolEligibleCounts() external view returns (uint256, uint256, uint256, uint256)",
  
  // General contract info
  "function getTotalUsers() external view returns (uint256)",
  "function getReservePoolBalance() external view returns (uint256)",
  "function getRouterPoolBalance() external view returns (uint256)",
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",
  
  // Transaction functions
  "function register(uint256 referrerId) external",
  "function upgradePackage(uint256 packageId) external",
  "function retopupPackage(uint256 packageId) external",
  "function claimIncome() external",
  "function claimAllPoolIncomes() external",
  
  // Admin functions
  "function adminRegister(address userAddress, uint256 referrerId) external",
  "function adminUpgradePackage(uint256 userId, uint256 packageId) external",
  "function adminRetopupPackage(uint256 userId, uint256 packageId) external",
  "function setGalaxyPoolIncome(uint256 amountPerUser) external",
  "function setCosmosPoolIncome(uint256 amountPerUser) external",
  "function setUniversePoolIncome(uint256 amountPerUser) external", 
  "function setEternalPoolIncome(uint256 amountPerUser) external",
  "function claimReservePool() external",
  "function claimRouterPool() external",
  "function resetWeeklyPools() external",
  "function resetMonthlyPools() external",
  "function resetAllPoolAccumulations() external",
  "function emergencyWithdraw(uint256 amount) external",
  
  // Events
  "event UserRegistered(uint256 indexed userId, address indexed userAddress, uint256 indexed referrerId)",
  "event PackageActivated(uint256 indexed userId, uint256 indexed packageId)",
  "event PackageRetoppedUp(uint256 indexed userId, uint256 indexed packageId, uint256 amount, uint256 newLimit)",
  "event SponsorIncome(uint256 indexed fromId, uint256 indexed toId, uint256 amount, uint256 packageId)",
  "event LevelIncome(uint256 indexed fromId, uint256 indexed toId, uint256 amount, uint256 level, uint256 packageId)",
  "event Claimed(uint256 indexed userId, uint256 amount)",
  "event PoolIncomeClaimed(uint256 indexed userId, uint256 indexed poolType, uint256 amount, uint256 fromRound, uint256 toRound)",
  "event PoolEligibilityUpdated(uint256 indexed userId, uint256 indexed poolType, bool eligible)",
  "event MatrixPlacement(uint256 indexed userId, uint256 indexed uplineId, uint256 indexed packageId, uint256 position)",
  "event LevelCompleted(uint256 indexed userId, uint256 indexed packageId, uint256 level)",
  "event ReservePoolClaimed(uint256 amount, uint256 timestamp)",
  "event RouterPoolClaimed(uint256 amount, uint256 timestamp)",
  "event PoolAccumulationReset(uint256 poolType, uint256 previousAmount, uint256 timestamp)"
];